export const environment = {
    production: true,
    liveedit: false,
    AUTH_BASE_URL: "https://www.drxwebservices.com/spa2026",
    WEB_SERVICE_BASE_URL: "https://www.drxwebservices.com/spa2026",
    LIVE_EDIT_CONFIG_URL: "https://www.drxwebservices.com/spa2026/v1/sites",
    ENROLLMENT_FORM_BASE_URL: "https://www.drxwebservices.com/spa2026/v1/enroll",
    MEMBER_SESSION_BASE_URL: "https://www.drxwebservices.com/spa2026/v1/session",
    ENROLLMENT_ASSETS_URL: "https://contentserver.destinationrx.com/drxproductcontent/phoenix/assets/enrollment2026",
    SOA_BASE_URL: "https://www.drxwebservices.com/spa2026/v1/soa",
    SSO_BASE_URL: "https://www.drxwebservices.com/spa2026/v1/sso",
    NEXTGEN_ENROLLMENT_ASSETS_URL: "https://contentserver.destinationrx.com/nextgen"
};
